import {
  deleteClient,
  DeleteClientData,
  EditClientRemark,
  editClientRemark,
  getAgentKey,
  getClientHash,
  GetClientHashData,
  getClientList,
  resetAgentKey,
  ClientRemark,
  clientRemark,
  Getagentlist,
  getagentlist,
  Putoperate,
  putoperate,
  Getagentarea,
  getagentarea,
  Getpackagelist,
  getpackagelist,
  Getpackagehash,
  getpackagehash,
  Packagedownload,
  packagedownload,
  Getmemberall,
  getmemberall,
  Getmemberbind,
  getmemberbind,
  AgentClientaddarea,
  agentClientaddarea,
  PutagentClientarea,
  putagentClientarea,
  Deletearea,
  deletearea,
  Addareamember,
  addareamember,
  Getarea,
  getarea,
  Deleteareamember,
  deleteareamember,
  updateAlias,
  UpdateAlias,
  updatearea,
  Updatearea,
  uninstallClient,
  UninstallClientData,
  getIp,
  batchDeleteClient,
  batchUnloadClient,
  logsCollectStart,
  logsCollectStop,
  logsRetention,
  logsRecord,
  logsDownload,
  logsDelete,
  getDownloadParams,
  getAgentHostAndPort,
} from '@/api/client'
import { Message } from '@/components/message'
import { t } from '@/i18n'
import { useRequest } from 'ahooks'

export const useClientHash = () => {
  const { runAsync } = useRequest((datas: GetClientHashData) => getClientHash(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('hash获取失败'))
    },
  })

  return [runAsync] as const
}

export const useClientList = () => {
  const { data, run } = useRequest(getClientList, {
    onError(err: any) {
      Message.error(err?.msg || t('客户端列表获取失败'))
    },
  })

  return [data?.data?.items || [], run] as const
}
export const useUninstallClient = () => {
  const { runAsync } = useRequest((params: UninstallClientData) => uninstallClient(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('卸载失败'))
    },
  })

  return [runAsync] as const
}
export const useDeleteClient = () => {
  const { runAsync } = useRequest((params: DeleteClientData) => deleteClient(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除失败'))
    },
  })

  return [runAsync] as const
}
export const useEditRemark = () => {
  const { runAsync } = useRequest((datas: EditClientRemark) => editClientRemark(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('编辑失败'))
    },
  })

  return [runAsync] as const
}

export const useGetAgentKey = () => {
  const { data, run } = useRequest(getAgentKey, {
    onError(err: any) {
      Message.error(err?.msg || t('秘钥获取失败'))
    },
  })

  return [data?.data || {}, run] as const
}

export const useResetAgentKey = () => {
  const { runAsync, loading } = useRequest(resetAgentKey, {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('秘钥生成失败'))
    },
  })

  return [runAsync, loading] as const
}

export const useClientRemark = () => {
  const { runAsync: run, loading } = useRequest((datas: ClientRemark) => clientRemark(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('自动更新修改失败'))
    },
  })

  return [run, loading] as const
}
// 修改别名
export const useUpdateAlias = () => {
  const { runAsync: run, loading } = useRequest((datas: UpdateAlias) => updateAlias(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('修改别名失败'))
    },
  })

  return [run, loading] as const
}

// 客户端
// 获取客户端列表
interface GetagentProps {
  GetagentParams: Getagentlist
}
export const useGetagentlist = (props: GetagentProps) => {
  const { GetagentParams } = props
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest(() => getagentlist(GetagentParams), {
    // manual: true,
    refreshDeps: [GetagentParams],
    onError(err: any) {
      Message.error(err?.msg || t('获取客户端列表失败'))
    },
  })

  return [run, data?.data?.items || [], loading] as const
}

// 编辑客户端
export const usePutoperate = () => {
  const { runAsync } = useRequest((datas: Putoperate) => putoperate(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('编辑客户端失败'))
    },
  })

  return [runAsync] as const
}

// 获取所有安全域
export const useGetagentarea = () => {
  const { runAsync: run } = useRequest((params: Getagentarea) => getagentarea(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取所有安全域失败'))
    },
  })

  return [run] as const
}

//获取安装包列表
export const useGetpackagelist = () => {
  const { runAsync: run } = useRequest((params: Getpackagelist) => getpackagelist(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安装包列表失败'))
    },
  })

  return [run] as const
}

//获取安装包hash
export const useGetpackagehash = () => {
  const { runAsync: run } = useRequest((params: Getpackagehash) => getpackagehash(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安装包hash失败'))
    },
  })

  return [run] as const
}

// 下载客户端
export const usePackagedownload = () => {
  const { runAsync, loading } = useRequest((data: Packagedownload) => packagedownload(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('下载客户端失败'))
    },
  })
  return [runAsync, loading] as const
}
// 更新安全域
export const useUpdatearea = () => {
  const { runAsync } = useRequest((data: Updatearea) => updatearea(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('更新安全域失败'))
    },
  })
  return [runAsync] as const
}
// 安全域
// 获取所有客户端/站点/邮箱
export const useGetmemberall = () => {
  const { runAsync: run, data } = useRequest((params: Getmemberall) => getmemberall(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取所有客户端/站点/邮箱失败'))
    },
  })

  return [run, data?.data || []] as const
}

// 获取安全域下所有绑定的成员
export const useGetmemberbind = () => {
  const { runAsync: run, data } = useRequest((params: Getmemberbind) => getmemberbind(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安全域下所有绑定的成员失败'))
    },
  })

  return [run, data?.data?.member] as const
}

// 添加安全域
export const useAgentClientaddarea = () => {
  const { runAsync, loading } = useRequest((data: AgentClientaddarea) => agentClientaddarea(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('添加安全域失败'))
    },
  })
  return [runAsync, loading] as const
}

// 编辑安全域
export const usePutagentClientarea = () => {
  const { runAsync, loading } = useRequest((data: PutagentClientarea) => putagentClientarea(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('编辑安全域失败'))
    },
  })
  return [runAsync, loading] as const
}

// 删除安全域
export const useDeletearea = () => {
  const { runAsync, loading } = useRequest((data: Deletearea) => deletearea(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除安全域失败'))
    },
  })
  return [runAsync, loading] as const
}

// 添加安全域成员
export const useAddareamember = () => {
  const { runAsync, loading } = useRequest((data: Addareamember) => addareamember(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('添加安全域成员失败'))
    },
  })
  return [runAsync, loading] as const
}

// 获取安全域列表
export const useGetarea = () => {
  const { data, runAsync: run } = useRequest((params: Getarea) => getarea(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安全域列表失败'))
    },
  })

  return [data?.data?.items || [], run] as const
}

// 删除绑定关系
export const useDeleteareamember = () => {
  const { runAsync, loading } = useRequest((data: Deleteareamember) => deleteareamember(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除绑定关系失败'))
    },
  })
  return [runAsync, loading] as const
}

//获取IP地址
export const useGetIp = () => {
  const { runAsync, data } = useRequest(() => getIp(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取ip地址失败'))
    },
  })
  return [runAsync, data?.data || {}] as const
}

// 批量删除客户端
export const useBatchDeleteClient = () => {
  const { runAsync: run } = useRequest((params: any) => batchDeleteClient(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('批量删除客户端失败'))
    },
  })

  return [run] as const
}

// 批量卸载客户端
export const useBatchUnloadClient = () => {
  const { runAsync: run } = useRequest((params: any) => batchUnloadClient(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('批量卸载客户端失败'))
    },
  })

  return [run] as const
}

// 开始收集日志
export const useLogsCollectStart = () => {
  const { runAsync: run } = useRequest((params: any) => logsCollectStart(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('开始收集日志失败'))
    },
  })

  return [run] as const
}

// 停止收集日志
export const useLogsCollectStop = () => {
  const { runAsync: run } = useRequest((params: any) => logsCollectStop(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('停止收集日志失败'))
    },
  })

  return [run] as const
}

// 更新日志存储时间
export const useLogsRetention = () => {
  const { runAsync: run } = useRequest((params: any) => logsRetention(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('更新日志存储时间失败'))
    },
  })

  return [run] as const
}

// 获取收集运行日志记录
export const useGetLogsRecord = () => {
  const { data, runAsync: run } = useRequest((params: any) => logsRecord(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取收集运行日志记录失败'))
    },
  })

  return [run, data?.data] as const
}

// 下载日志
export const useLogsDownload = () => {
  const { runAsync: run, loading } = useRequest((params: any) => logsDownload(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('下载日志失败'))
    },
  })

  return [run, loading] as const
}

// 删除日志
export const useLogsDelete = () => {
  const { runAsync: run, loading } = useRequest((params: any) => logsDelete(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除日志失败'))
    },
  })

  return [run, loading] as const
}

// 获取下载参数
export const useGetDownloadParams = () => {
  const { runAsync: run, data } = useRequest((params: any) => getDownloadParams(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取下载参数失败'))
    },
  })
  return [run, data?.data || {}] as const
}

// 获取agent需要的host和port信息
export const useGetAgentHostAndPort = () => {
  const { runAsync: run, data } = useRequest(() => getAgentHostAndPort(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取agent需要的host和port信息失败'))
    },
  })
  return [run, data?.data || {}] as const
}
